module.exports = __webpack_public_path__ + "assets/img/4.65af19b8.png";